import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { ParsedInsuranceRateType } from "../../../../shared-logic/types/FinanceInsuranceRateTypes";
import type { InsuranceRateStateType } from "../../../../shared-logic/types/InsuranceTypes";

export type CarConfigInsuranceActionsType = ReturnType<
    | typeof startInsuranceRateFetch
    | typeof finishInsuranceFetch
    | typeof setInsurancePersonalized
    | typeof errorInsuranceRateFetch
    | typeof clearInsuranceRate
>;
export const initialState: InsuranceRateStateType = {
    fetching: false,
    error: false,
    total: 0,
    isPersonalizedQuote: false,
    quoteInfo: {},
    info: {
        disclaimer: { value: "" },
    },
};

export const CarConfigInsuranceSlice = createSlice({
    name: "insurance",
    initialState,
    reducers: {
        startInsuranceRateFetch(state) {
            return {
                ...state,
                fetching: true,
                error: false,
            };
        },
        finishInsuranceFetch(state, action: PayloadAction<{ result: ParsedInsuranceRateType }>) {
            const { legalText, total, quoteInfo, name } = action.payload.result;
            const info = {
                disclaimer: legalText,
            };

            return { ...state, total, info, name, quoteInfo: quoteInfo || {}, fetching: false };
        },
        setInsurancePersonalized(state, action: PayloadAction<boolean>) {
            return {
                ...state,
                isPersonalizedQuote: action.payload,
            };
        },
        errorInsuranceRateFetch(state) {
            return {
                ...state,
                fetching: false,
                error: true,
            };
        },
        clearInsuranceRate() {
            return {
                ...initialState,
            };
        },
    },
});

export const {
    startInsuranceRateFetch,
    finishInsuranceFetch,
    setInsurancePersonalized,
    errorInsuranceRateFetch,
    clearInsuranceRate,
} = CarConfigInsuranceSlice.actions;
